var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { getPrivateAttributes } from '@ally/private';
import { FormTextWrapper } from '../shared';
import { filterTextAreaProps } from '../utils';
import { propsToForward } from '../../tools/utils';
var StyledTextArea = styled.textarea.withConfig({
    shouldForwardProp: propsToForward,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var $resizable = _a.$resizable;
    return "\n    min-width: 0;\n    resize: ".concat($resizable ? 'vertical' : 'none', ";\n  ");
});
var TextArea = React.forwardRef(function (props, ref) {
    var resizable = props.resizable, isPrivate = props.isPrivate;
    var privateAttrs = isPrivate ? getPrivateAttributes() : {};
    return (React.createElement(FormTextWrapper, null,
        React.createElement(StyledTextArea, __assign({}, filterTextAreaProps(props), { ref: ref, "$resizable": !!resizable }, privateAttrs))));
});
var TextAreaWithMarginProps = styled(TextArea)(margin);
export { TextAreaWithMarginProps as TextArea };
var templateObject_1;
//# sourceMappingURL=TextArea.js.map